import React from 'react';
import {
    Box,
    Flex,
    HStack,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuOptionGroup,
    MenuItemOption,
    MenuDivider,
    useColorModeValue,
} from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

export default function HeaderNav() {
    const { session, logout } = useAuth();
    const navigate = useNavigate();
    const bg = useColorModeValue('white', 'gray.800');
    const hoverBg = useColorModeValue('gray.100', 'gray.700');
    const { t, i18n } = useTranslation();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const changeLang = (value) => i18n.changeLanguage(value);

    return (
        <Box bg={bg} px={4} boxShadow="sm">
            <Flex
                h={16}
                align="center"
                justify="space-between"
                maxW="1200px"
                mx="auto"
            >
                {/* Logo */}
                <Button
                    as={Link}
                    to="/"
                    variant="ghost"
                    fontSize="xl"
                    fontWeight="bold"
                    _hover={{ bg: hoverBg }}
                >
                    {t('header.logo')}
                </Button>

                <HStack spacing={4}>
                    {session ? (
                        <>
                            {/* Journal */}
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    variant="ghost"
                                    rightIcon={<ChevronDownIcon />}
                                    _hover={{ bg: hoverBg }}
                                >
                                    {t('header.auth.meals')}
                                </MenuButton>
                                <MenuList>
                                    <MenuItem as={Link} to="/meal-journal">
                                        {t('header.auth.mealJournal')}
                                    </MenuItem>
                                    {/*<MenuItem as={Link} to="/workout-journal">*/}
                                    {/*    {t('header.auth.workoutJournal', "Workout Journal")}*/}
                                    {/*</MenuItem>*/}
                                    <MenuItem as={Link} to="/meal-planner">
                                        {t('header.auth.mealPlanner') }
                                    </MenuItem>
                                </MenuList>
                            </Menu>

                            {/* Settings (now includes Language) */}
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    variant="ghost"
                                    rightIcon={<ChevronDownIcon />}
                                    _hover={{ bg: hoverBg }}
                                >
                                    {t('header.auth.settings')}
                                </MenuButton>
                                <MenuList>
                                    <MenuItem as={Link} to="/setup-profile">
                                        {t('header.auth.editProfile')}
                                    </MenuItem>
                                    <MenuDivider />

                                    {/* Language radio group */}
                                    <MenuOptionGroup
                                        title={t('header.language.title', 'Language')}
                                        type="radio"
                                        defaultValue={i18n.language}
                                        onChange={changeLang}
                                    >
                                        <MenuItemOption value="en">
                                            {t('header.language.en')}
                                        </MenuItemOption>
                                        <MenuItemOption value="kr">
                                            {t('header.language.kr')}
                                        </MenuItemOption>
                                    </MenuOptionGroup>
                                    <MenuDivider />

                                    <MenuItem onClick={handleLogout}>
                                        {t('header.auth.logout')}
                                    </MenuItem>
                                </MenuList>
                            </Menu>
                        </>
                    ) : (
                        /* unauth links */
                        <>
                            <Button
                                as={Link}
                                to="/features"
                                variant="ghost"
                                _hover={{ bg: hoverBg }}
                            >
                                {t('header.auth.features')}
                            </Button>
                            <Button
                                as={Link}
                                to="/login"
                                variant="ghost"
                                _hover={{ bg: hoverBg }}
                            >
                                {t('header.auth.login')}
                            </Button>
                            <Button
                                as={Link}
                                to="/register"
                                colorScheme="blue"
                                _hover={{ bg: 'blue.600' }}
                            >
                                {t('header.auth.signup')}
                            </Button>
                        </>
                    )}
                </HStack>
            </Flex>
        </Box>
    );
}